import { CONFIG } from 'config/environment_variables';
import { getServerName } from 'utils/functions/server';

const serverName = getServerName();
export const isProductionServer = serverName === 'production';
export const isStagingServer = serverName === 'staging';
export const isDevelopmentServer = serverName === 'dev';
export const isLocalServer = CONFIG.NODE_ENV === 'development';
